import { createFeatureSelector, createSelector } from '@ngrx/store'
import { Features } from '../../../../../state/features.enum'
import { FieldState, fieldAdapter } from '../reducers/field.reducer'

export const fieldsSelector = createFeatureSelector<FieldState>(Features.FIELD)

export const selectFields = createSelector(fieldsSelector, fieldAdapter?.getSelectors()?.selectAll)

export const selectFieldById = (fieldId: number) =>
  createSelector(selectFields, (f) => f.filter((field) => field?.id === fieldId)[0])

export const selectFieldsByFarmId = (farmId: number | undefined) =>
  createSelector(selectFields, (f) => f.filter((fields) => fields?.farmId === farmId) || [])
